import { buttonVariants, Card, CardContent, CardHeader, CardTitle, cn } from '@napaicp/ui'
import { GraduationCap, Scale, Settings2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const ROLES = [
  { key: 'student', icon: GraduationCap },
  { key: 'judge', icon: Scale },
  { key: 'admin', icon: Settings2 },
] as const

/**
 * Role entry points on `/`. PR-053 (v3.1.2, TASK-U-009): `/` now renders for
 * every visitor, signed in or not, so a card can be clicked by an already
 * authenticated visitor too — every card still routes to `/login` rather
 * than the role area itself, since the area has no route guard of its own
 * and would otherwise render a broken, silently-empty dashboard. `/login`
 * itself redirects an authenticated session straight to `/app`, which uses
 * `resolveSignedInHome` to land on the area matching the account's actual
 * role, whichever card was clicked.
 */
export function RoleCards() {
  const { t } = useTranslation('home')

  return (
    <section id="roles" className="flex scroll-mt-20 flex-col gap-4 pt-1 pb-4 md:pt-2 md:pb-6">
      <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">{t('roles.heading')}</h2>
      <div className="grid gap-6 sm:grid-cols-3">
        {ROLES.map(({ key, icon: Icon }) => (
          <Card key={key} className="flex flex-col">
            <CardHeader>
              <Icon className="size-8 text-primary" aria-hidden="true" />
              <CardTitle className="text-xl">{t(`roles.${key}.title`)}</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-1 flex-col gap-5">
              <p className="flex-1 text-lg text-muted-foreground">
                {t(`roles.${key}.description`)}
              </p>
              <Link
                className={cn(buttonVariants({ variant: 'outline', size: 'lg' }), 'text-lg')}
                to="/login"
              >
                {t(`roles.${key}.cta`)}
              </Link>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  )
}
